import Footer from "../../components/Footer";
import Navbar from "../../components/Navbar";
import Event from "../../components/Event";
import Introduction from "../../components/Introduction";
import "./EventPage.css";
import DefaultPage from "../DefaultPage/DefaultPage";
import useFetch from "../../hooks/useFetch";
import config from "../../config";
import { useEffect, useMemo, useState } from "react";
import Loader from "../../components/Loader";
import ButtonV2 from "../../components/ButtonV2";

const EventPage = () => {
  //aktuální datum v memoized z duvodu nekonečneho re-renderovani
  const currentDate = useMemo(() => new Date().toISOString(), []);

  //fetch stránky (uvod)
  const {
    loading: loadingIntroduction,
    error: errorIntroduction,
    data: dataIntroduction,
  } = useFetch(`${config.api}/api/events-page?populate=background`);

  const [status, setStatus] = useState("passed");

  //url v useState pro dynamickou zmenu url kvuli re-renderu
  const [url, setUrl] = useState(
    `${config.api}/api/events?filters[date][$gte]=${currentDate}&sort[0]=date:asc`
  );

  //metoda pro stisk tlacitka pro prepinani stavu
  const handleStatusClick = (status_var) => {
    setStatus(status_var);

    //? test
    //? console.log(status);
    //? console.log(dataIntroduction);
  };

  useEffect(() => {
    if (status === "passed") {
      // const currentdate je ok, protoze ho vytvarim ve function scopu
      const currentDate = new Date().toISOString();
      setUrl(
        `${config.api}/api/events?filters[date][$lt]=${currentDate}&sort[0]=date:desc`
      );
    } else if (status === "planned") {
      const currentDate = new Date().toISOString();
      setUrl(
        `${config.api}/api/events?filters[date][$gte]=${currentDate}&sort[0]=date:asc`
      );
    }
  }, [status]);

  //fetch udalosti
  const { loading, error, data } = useFetch(url);

  // možné stavy při/po fetchi
  if (loadingIntroduction) return <Loader />;
  if (errorIntroduction)
    return <DefaultPage message="Chyba při načítání úvodu" />;

  if (loading) return <Loader />;
  if (error) return <DefaultPage message="Chyba při načítání událostí" />;
  if (!data || !data.data) return <DefaultPage message="Žádné udalosti" />;

  //? test
  //? console.log("eventy", data);

  //změna titulku stránky v prohlížeči
  document.title = dataIntroduction.data.title;

  return (
    <div className="min-height-100 d-flex flex-column container-fluid background-white">
      <Navbar />
      <Introduction
        title={dataIntroduction.data.title}
        text={dataIntroduction.data.description}
        image={dataIntroduction.data.background.url}
      />
      <div className="container-fluid sub-nav">
        <div className="container d-flex justify-content-center">
          <div
            onClick={() => handleStatusClick("passed")}
            className={`m-2 ${status === "passed" ? "" : ""}`}
          >
            <ButtonV2 text="Uplynulé" />
          </div>
          <div
            onClick={() => handleStatusClick("planned")}
            className={`m-2 ${status === "planned" ? "" : ""}`}
          >
            <ButtonV2 text="Plánované" />
          </div>
        </div>
      </div>
      <div className="container-fluid background-white">
        <div className="container container-background p-5 d-flex flex-column justify-content-center align-items-center">
          <h2 className="text-center">
            {status === "passed" ? "Uplynulé" : "Plánované"} projekty
          </h2>
          {data.data.map((event) => (
            <Event
              key={event.id}
              id={event.documentId}
              name={event.name}
              date={event.date}
              overview={event.overview}
            />
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};
export default EventPage;
